module.exports = __webpack_public_path__ + "static/media/bgWorkoutsPage.34bb2624.jpg";